export enum EScrollDirection {
  UP = 'up',
  DOWN = 'down',
  NONE = 'none',
}
